import { Box, Container } from '@mui/material';
import type { ReactNode } from 'react';

import logo from '@/assets/logo.png';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps): JSX.Element {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        py: 4,
      }}
    >
      <Container maxWidth="xs">
        <Box
          component="img"
          src={logo as string}
          alt="Sistema DPV"
          sx={{
            display: 'block',
            mx: 'auto',
            mb: 3,
            height: 'auto',
            maxWidth: 280,
            width: '100%',
          }}
        />
        {children}
      </Container>
    </Box>
  );
}
